
(function (w, d) {
  'use strict';

  var DL = w.DJIDataLayer;
  if (!DL) return;
  if ((DL.ctx.page_type || '') !== 'collection') return;
  if (w.__djiCollectionTracking) return;
  w.__djiCollectionTracking = 1;

  var CTX = DL.ctx.collection || {};

  /* ================================================================ */
  
  /* ================================================================ */

  var CFG = {
    grid:   { component_id: 'collection_product_grid', placement: 'collection_grid' },
    filter: { component_id: 'collection_filter',       placement: 'collection_sidebar' },
    sort:   { component_id: 'collection_sort',         placement: 'collection_top_right' },
    page:   { component_id: 'collection_pagination',   placement: 'collection_grid' },
    subcat: { component_id: 'collection_subcategory',  placement: 'collection_grid' }
  };

  
  var SEL = {
    
    gridCandidates: ['#gf-products', '[data-globo-filter-items]', '.collection-products-list'],
    card:        '.spf-product-card',
    productForm: 'product-form[data-product-id]',
    variantInput:'form[action*="/cart/add"] input[name="id"]',
    atc:         'button.product-card-atc, button[name="add"]',

    filterBlock: '.gf-option-block[data-filter-id]',
    filterTitle: '.gf-block-title',
    filterLink:  '.gf-option-box a, .gf-option-block a',
    filterInput: '.gf-option-block input[type="checkbox"], .gf-option-block input[type="radio"]',
    
    filterClear: '.gf-actions a, .gf-actions button, .gf-filter-selection a',
    filterClearText: /borrar|limpiar|clear|quitar|reset|elimina/i,

    sortHost:    '.sort-by',
    sortToggle:  '#sortButton, .sort-by-toggle',
    
    sortOption:  '.globo-dropdown-custom__options li[data-sort], .globo-dropdown-custom__options li[data-value], .sort-by li[data-sort], .sort-by li[data-value]',

    pager:       '.pagination a, [class*="load-more"], button[class*="more"]',
    
    subcat:      '[data-subcategory] a, .gf-subcategory a, [class*="subcategory"] a',

    totalCount:  '[total-product-count], .gf-summary, [class*="results-count"]'
  };

  /* ================================================================ */
  
  /* ================================================================ */

  function all(root, sel) { return root ? [].slice.call(root.querySelectorAll(sel)) : []; }
  function txt(el) { return el && el.innerText ? el.innerText.trim().replace(/\s+/g, ' ').slice(0, 80) : ''; }
  function visible(el) {
    if (!el) return false;
    var r, s;
    try { r = el.getBoundingClientRect(); s = w.getComputedStyle(el); } catch (e) { return false; }
    return s.display !== 'none' && s.visibility !== 'hidden' && r.height > 0;
  }

  
  function gridEl() {
    var best = null, bestN = 0, fallback = null;
    for (var i = 0; i < SEL.gridCandidates.length; i++) {
      var el = d.querySelector(SEL.gridCandidates[i]);
      if (!el || !visible(el)) continue;
      if (!fallback) fallback = el;
      var n = el.querySelectorAll(SEL.card).length;
      if (n > bestN) { bestN = n; best = el; }
    }
    return best || fallback;
  }

  function cards() { return all(gridEl() || d, SEL.card).filter(visible); }

  function productIdOf(card) {
    var pf = card.querySelector(SEL.productForm);
    if (pf) return String(pf.getAttribute('data-product-id') || '');
    var any = card.querySelector('[data-product-id]');
    return any ? String(any.getAttribute('data-product-id') || '') : '';
  }

  function variantIdOf(card) {
    var i = card.querySelector(SEL.variantInput);
    return i && i.value ? String(i.value) : '';
  }

  function hrefOf(card) {
    var a = card.querySelector('a[href*="/products/"]');
    return a ? a.getAttribute('href') : '';
  }

  
  function filterIdMap() {
    var map = {};
    all(d, SEL.filterBlock).forEach(function (b) {
      var id = b.getAttribute('data-filter-id');
      if (!id) return;
      map[id] = b.getAttribute('data-filter-type') || txt(b.querySelector(SEL.filterTitle)) || id;
    });
    return map;
  }

  function activeFilters() {
    var out = [];
    var map = filterIdMap();
    try {
      var q = new w.URLSearchParams(w.location.search);
      q.forEach(function (v, k) {
        if (!/^filter\./i.test(k)) return;
        var id = k.replace(/^filter\./i, '');
        out.push((map[id] || id) + '=' + v);
      });
    } catch (e) {}
    out.sort();                       
    return out;
  }

  
  function sortValueOf(li) {
    if (!li) return '';
    return li.getAttribute('data-sort') || li.getAttribute('data-value') || '';
  }

  function currentSort() {
    try {
      var q = new w.URLSearchParams(w.location.search);
      var s = q.get('sort_by');
      if (s) return s;
    } catch (e) {}
    
    var btn = d.querySelector(SEL.sortToggle);
    if (btn) {
      var label = txt(btn);
      var hit = all(d, SEL.sortOption).filter(function (li) { return txt(li) === label; })[0];
      if (hit) return sortValueOf(hit);
    }
    return CTX.current_sort || '';
  }

  function resultsCount() {
    
    var n = cards().length;
    if (n) return n;
    var el = d.querySelector(SEL.totalCount);
    if (el) {
      var m = txt(el).match(/\d+/);
      if (m) return Number(m[0]);
    }
    return 0;
  }

  function base(cfg, extra) {
    var af = activeFilters();
    var out = {
      page_type: 'collection',
      component_id: cfg.component_id,
      placement: cfg.placement,
      collection_id: CTX.id != null ? String(CTX.id) : undefined,
      collection_handle: CTX.handle,
      active_filters: af.join('|'),          
      active_filter_count: af.length,
      current_sort: currentSort()
    };
    for (var k in (extra || {})) out[k] = extra[k];
    return out;
  }

  
  function cardElementId(t) {
    if (t.closest('img, picture, [class*="image"], [class*="media"]')) return 'product_image';
    if (t.closest('[class*="title"], h2, h3, h4')) return 'product_title';
    return 'product_card';
  }

  
  var CARD_TITLE = '[class*="product-title"], [class*="card__title"], h3, h2';
  var CARD_PRICE = '[class*="price"]';

  function cardTitle(card) {
    var t = txt(card.querySelector(CARD_TITLE));
    return t || '';
  }

  /** "Precio habitual $87,599 MXN" → 87599 */
  function cardPrice(card) {
    var raw = txt(card.querySelector(CARD_PRICE));
    if (!raw) return undefined;
    var m = raw.replace(/\s/g, '').match(/([\d.,]+)/g);
    if (!m || !m.length) return undefined;
    
    var num = m[m.length - 1].replace(/,/g, '');
    var v = parseFloat(num);
    return isNaN(v) ? undefined : v;
  }

  function cardAvailability(card) {
    if (card.classList && (card.classList.contains('spf-soldout') ||
        card.className.indexOf('soldout') > -1)) return 'out_of_stock';
    return 'in_stock';
  }

  
  function itemOf(card, index) {
    var pid = productIdOf(card);
    if (!pid) return null;
    return DL.item(pid, {
      index: index,
      item_list_id: 'collection_' + (CTX.handle || 'all'),
      item_list_name: CTX.title || CTX.handle || 'Collection',
      variant_id: variantIdOf(card) || undefined,
      item_name: cardTitle(card) || undefined,
      price: cardPrice(card),
      availability: cardAvailability(card)
    });
  }

  /* ================================================================ */
  
  /* ================================================================ */

  var batchIndex = 0;
  var pendingTrigger = null;      
  var stopObserve = null;

  function emitBatch(trigger) {
    var grid = gridEl();
    if (!grid) return;

    var list = cards();
    
    if (!list.length) return;

    batchIndex += 1;
    var thisBatch = batchIndex;
    gridSignature = currentSignature();   
    firstBatchDone = true;
    var af = activeFilters().join('|');
    var sort = currentSort();
    var key = 'view_item_list|collection_' + (CTX.handle || 'all') + '|' + af + '|' + sort + '|' + thisBatch;

    
    if (stopObserve) { stopObserve(); stopObserve = null; }

    stopObserve = DL.observe(grid, { ratio: 0.5, dwell: 1000 }, function (el, meta) {
      stopObserve = null;
      if (!DL.once(key)) return;
      var now = cards();
      var items = now.map(function (c, i) { return itemOf(c, i + 1); }).filter(Boolean);
      if (!items.length) return;
      DL.push('view_item_list', base(CFG.grid, {
        item_list_id: 'collection_' + (CTX.handle || 'all'),
        item_list_name: CTX.title || CTX.handle || 'Collection',
        list_batch_index: thisBatch,
        trigger_source: trigger,            /* initial / filter / sort / load_more */
        exposure_rule: meta.rule,
        exposure_ratio: meta.ratio_observed,
        items: items
      }));
    });
  }

  
  function waitFirstBatch() {
    var tries = 0;
    (function poll() {
      if (cards().length) { emitBatch('initial'); return; }
      if (++tries < 40) w.setTimeout(poll, 250);   
      else DL.log('collection: 10s 内未渲染出商品卡，C1 未发送');
    })();
  }

  
  var gridSignature = '';
  var firstBatchDone = false;

  function currentSignature() {
    return cards().map(function (c) { return productIdOf(c); }).join(',');
  }

  function watchRerender() {
    var settle = null;

    function check() {
      var now = currentSignature();
      if (now === gridSignature) return;
      gridSignature = now;
      if (!now) return;                       

      
      if (!firstBatchDone) return;

      var trigger = pendingTrigger || 'load_more';
      pendingTrigger = null;
      emitBatch(trigger);
    }

    try {
      new MutationObserver(function () {
        if (settle) w.clearTimeout(settle);
        settle = w.setTimeout(check, 400);
      }).observe(d.body, { childList: true, subtree: true });
    } catch (e) {}
  }

  /* ================================================================ */
  
  /* ================================================================ */

  
  var FILTER_GROUPS = [
    [/serie|series|collection/i,      'product_series'],
    [/tipo|type|categor/i,            'product_type']
  ];

  function filterGroupOf(el) {
    var block = el.closest(SEL.filterBlock);
    if (!block) return { id: '', name: '' };
    var raw = block.getAttribute('data-filter-type') || txt(block.querySelector(SEL.filterTitle)) || '';
    var mapped = '';
    for (var i = 0; i < FILTER_GROUPS.length; i++) {
      if (FILTER_GROUPS[i][0].test(raw)) { mapped = FILTER_GROUPS[i][1]; break; }
    }
    return {
      id: block.getAttribute('data-filter-id') || '',
      name: mapped || raw,       
      raw: raw
    };
  }

  
  function filterValueOf(a) {
    var oc = a.getAttribute('onclick') || '';
    var m = oc.match(/\(\s*[\d'"]+\s*,\s*['"]([^'"]+)['"]/);
    if (m) return m[1];
    return a.getAttribute('data-value') || txt(a);
  }

  function initFilter() {
    d.addEventListener('click', function (evt) {
      var t = evt.target;
      if (!t || !t.closest) return;

      
      var clear = t.closest(SEL.filterClear);
      if (clear && !SEL.filterClearText.test(txt(clear))) clear = null;   
      if (clear) {
        var g0 = filterGroupOf(clear);
        pendingTrigger = 'filter';
        recordFilter('clear', g0, '', txt(clear));
        return;
      }

      var link = t.closest(SEL.filterLink);
      var input = t.closest(SEL.filterInput);
      if (!link && !input) return;

      var el = link || input;
      var g = filterGroupOf(el);
      if (!g.id) return;

      
      var willBeOn;
      if (input) willBeOn = !!input.checked;
      else willBeOn = !(el.classList && el.classList.contains('checked'));

      pendingTrigger = 'filter';
      recordFilter(willBeOn ? 'apply' : 'remove', g,
                   link ? filterValueOf(link) : (input.value || ''),
                   txt(el));
    }, true);
  }

  
  function recordFilter(action, group, valueId, valueName) {
    var prev = cards().length;
    var tries = 0;
    (function poll() {
      var now = cards().length;
      if ((now !== prev && now > 0) || tries > 20) {
        DL.push('filter_apply', base(CFG.filter, {
          action: action,
          filter_group: group.name || group.id || undefined,
          filter_value_id: valueId || undefined,
          filter_value_name: valueName || undefined,
          previous_results_count: prev,
          results_count: now
        }));
        return;
      }
      tries += 1;
      w.setTimeout(poll, 250);        
    })();
  }

  /* ================================================================ */
  
  /* ================================================================ */

  function initSort() {
    
    d.addEventListener('click', function (evt) {
      var t = evt.target;
      if (!t || !t.closest) return;
      var li = t.closest(SEL.sortOption);
      if (!li) return;

      var from = currentSort();
      var to = sortValueOf(li);
      if (!to || to === from) return;

      pendingTrigger = 'sort';

      
      var beforeSig = cards().map(productIdOf).join(',');
      var tries = 0;
      (function poll() {
        var nowSig = cards().map(productIdOf).join(',');
        if ((nowSig && nowSig !== beforeSig) || tries > 20) {
          DL.push('sort_change', base(CFG.sort, {
            sort_from: from,
            sort_to: to,
            results_count: resultsCount()
          }));
          return;
        }
        tries += 1;
        w.setTimeout(poll, 250);
      })();
    }, true);
  }

  /* ================================================================ */
  
  /* ================================================================ */

  var lastAdd = null;

  function initCardClicks() {
    d.addEventListener('click', function (evt) {
      var t = evt.target;
      if (!t || !t.closest) return;
      var card = t.closest(SEL.card);
      if (!card) return;

      var list = cards();
      var index = list.indexOf(card) + 1;

      
      if (t.closest(SEL.atc)) {
        var btn = t.closest(SEL.atc);
        if (!DL.isInteractive(btn)) return;
        lastAdd = {
          at: Date.now(),
          index: index,
          productId: productIdOf(card),
          variantId: variantIdOf(card),
          
          method: card.querySelector(SEL.productForm) ? 'product_form' : 'quick_add',
          impl: card.querySelector(SEL.productForm) ? 'theme_product_form' : 'app'
        };
        return;
      }

      /* C5 */
      var href = hrefOf(card);
      if (!href) return;
      var link = t.closest('a[href*="/products/"]') || card.querySelector('a[href*="/products/"]');
      DL.afterTick(function () {
        var __np = DL.navPush(evt, link || card);
        if (!__np) return;
        var item = itemOf(card, index);
        if (!item) return;
        __np('select_item', base(CFG.grid, {
          item_list_id: 'collection_' + (CTX.handle || 'all'),
          item_list_name: CTX.title || CTX.handle || 'Collection',
          
          element_id: cardElementId(t),
          index: index,
          destination_url: href,
          items: [item]
        }));
      });
    }, true);
  }

  function initAddToCart() {
    DL.onCartSuccess(function (kind, body) {
      if (kind !== 'add') return;
      var ctx = lastAdd && Date.now() - lastAdd.at < 10000 ? lastAdd : null;
      if (!ctx) return;
      lastAdd = null;

      var lines = [];
      if (body && body.items && body.items.length) lines = body.items;
      else if (body && body.id) lines = [body];

      DL.fetchCart().then(function (cart) {
        if (!cart) return;
        var items = DL.itemsFromCartLines(lines, {
          item_list_id: 'collection_' + (CTX.handle || 'all'),
          item_list_name: CTX.title || CTX.handle || 'Collection',
          index: ctx.index
        });
        if (!items.length) return;
        DL.push('add_to_cart', base(CFG.grid, {
          item_list_id: 'collection_' + (CTX.handle || 'all'),
          item_list_name: CTX.title || CTX.handle || 'Collection',
          element_id: 'quick_add',
          add_method: ctx.method,
          button_implementation: ctx.impl,
          index: ctx.index,
          cart_total_items: cart.item_count,
          value: DL.itemsValue(items),
          items: items
        }));
      });
    });
  }

  /* ================================================================ */
  
  /* ================================================================ */

  function initPagination() {
    d.addEventListener('click', function (evt) {
      var t = evt.target;
      if (!t || !t.closest) return;

      var sub = t.closest(SEL.subcat);
      if (sub) {
        var href = sub.getAttribute('href') || '';
        DL.afterTick(function () {
          var __np = DL.navPush(evt, sub);
          if (!__np) return;
          var m = href.match(/\/collections\/([^/?#]+)/);
          __np('category_entry_click', base(CFG.subcat, {
            category_id: m ? m[1] : undefined,
            category_level: 2,
            destination_url: href || undefined
          }));
        });
        return;
      }

      var pager = t.closest(SEL.pager);
      if (!pager) return;
      var isPage = pager.matches('.pagination a');
      var before = cards().length;
      pendingTrigger = 'load_more';

      
      var tries = 0;
      (function poll() {
        var now = cards().length;
        if (now !== before || tries > 24) {
          DL.push('item_list_load_more', base(CFG.page, {
            action: isPage ? 'page_change' : 'load_more',
            page_number: pageNumber(),
            loaded_item_count: isPage ? now : Math.max(0, now - before),
            item_list_id: 'collection_' + (CTX.handle || 'all')
          }));
          return;
        }
        tries += 1;
        w.setTimeout(poll, 250);      
      })();
    }, true);
  }

  function pageNumber() {
    try {
      var q = new w.URLSearchParams(w.location.search);
      return Number(q.get('page') || 1);
    } catch (e) { return 1; }
  }

  /* ================================================================ */
  
  /* ================================================================ */

  function start() {
    if (start.__done) return;
    start.__done = 1;
    initFilter();
    initSort();
    initCardClicks();
    initAddToCart();
    initPagination();
    waitFirstBatch();
    watchRerender();
    DL.log('collection tracking ready', {
      grid: gridEl() ? gridEl().id || gridEl().className : null,
      cards: cards().length
    });
  }

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', start);
  else start();
})(window, document);
